import {EmptyStatus, EmptyStatusProps, useTranslationContext} from 'platform/components';

import {TestIdProps, suffixTestId} from 'shared/web';

interface DefaultEmptyStateRendererProps extends TestIdProps {
  filterIsActive: boolean;
  disableFilter: () => void;
  emptyStatus?: Omit<EmptyStatusProps, 'variant'>;
}

export function DefaultEmptyStateRenderer(props: DefaultEmptyStateRendererProps) {
  const t = useTranslationContext();
  return props.filterIsActive ? (
    <EmptyStatus
      variant="table"
      action={{
        title: t('page.datagrid.labels.clearAllFilters'),
        onClick: props.disableFilter,
      }}
      data-testid={suffixTestId('empty-state-filter-active', props)}
      headline={t('page.datagrid.labels.emptyDueFilter')}
    />
  ) : (
    <EmptyStatus
      variant="table"
      headline={t('page.datagrid.labels.emptyData')}
      {...props.emptyStatus}
    />
  );
}
